<template>
    <div>
        <v-offline
            online-class="online"
            offline-class="offline"
            @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-sm-12">
                <h5>Records <i style="color: darkgrey" class="ti-angle-right small"></i> Awaiting Exam</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p>To search by date enter date in YYYY-MM-DD Format. Eg: 2024-01-31</p>
            </div>
            <div class="col-sm-12 col-xs-12 col-md-12 col-xl-12">
                <div class="card">
                    <div class="card-body">
                        <!-- View Toggle -->
                        <div class="row mb-3">
                            <div class="col-12 d-flex justify-content-end">
                                <div class="modern-view-toggle">
                                    <button type="button"
                                            :class="['toggle-btn', { 'active': viewMode === 'list' }]"
                                            @click="viewMode = 'list'">
                                        <i class="ti-view-list"></i>
                                        <span>List View</span>
                                    </button>
                                    <button type="button"
                                            :class="['toggle-btn', { 'active': viewMode === 'grid' }]"
                                            @click="toggleToGridView">
                                        <i class="ti-layout-grid2"></i>
                                        <span>Grid View</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Grid View Notice -->
                        <div v-if="viewMode === 'grid'" class="row mb-3">
                            <div class="col-12">
                                <div class="alert alert-info grid-view-notice" role="alert">
                                    <i class="ti-info-alt"></i>
                                    <div class="notice-content">
                                        <strong>Experimental Feature:</strong> Grid View is currently in beta.
                                        Counts per page, export, filter columns, search, and sort features are not available in this view.
                                        Grid View is designed for gallery-style browsing only. Switch to List View for full functionality.
                                    </div>
                                    <button type="button" class="close" @click="viewMode = 'list'">
                                        <span>&times;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- List/Table View -->
                        <div v-show="viewMode === 'list'" class="row set_row">
                            <!-- <div class="col-xl-1">
                            </div> -->
                            <div class="col-sm-12 col-xl-12 set_table_center">
                                <table id="notOperatedRecords" class="display table-striped table-bordered select"
                                       cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th><input type="checkbox" id="allCheckbox" @click="inputCheckBox"></th>
                                        <th>Caught Date</th>
                                        <th>Photo</th>
                                        <th>Collar ID</th>
                                        <th>Gender</th>
                                        <th>Caught Method</th>
                                        <th>Ownership</th>
                                        <th>RFID</th>
                                        <th>App ID</th>
                                        <th>Species</th>
                                        <th>Area</th>
                                        <th>Caught Location</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                            <!-- <div class="col-xl-1">
                            </div> -->
                        </div>

                        <!-- Grid View -->
                        <div v-show="viewMode === 'grid'" class="grid-view-container">
                            <div class="row">
                                <div v-for="(record, index) in gridData" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                                    <div class="record-card" :class="{'card-checked': isCardChecked(record.id)}">
                                        <div class="record-image">
                                            <div class="checkbox-overlay">
                                                <input type="checkbox"
                                                       class="grid-check-input"
                                                       :value="record.id"
                                                       :id="'grid-check-' + record.id"
                                                       @change="onCheckboxChange">
                                            </div>
                                            <div class="image-content" @click="zoomImagePopupGrid(record.photo)">
                                                <img :src="record.photo" alt="Record Photo" />
                                            </div>
                                        </div>
                                        <div class="record-details">
                                            <div class="detail-row">
                                                <strong>Caught Date:</strong>
                                                <span v-html="record.caughtDate"></span>
                                            </div>
                                            <div class="detail-row">
                                                <strong>Collar ID:</strong>
                                                <span>{{ record.collarId }}</span>
                                            </div>

                                            <!-- Expandable Details -->
                                            <div v-if="expandedCards[record.id]" class="expandable-details">
                                                <div class="detail-row">
                                                    <strong>Gender:</strong>
                                                    <span>{{ record.gender }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>Method:</strong>
                                                    <span>{{ record.caughtMethod }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>Ownership:</strong>
                                                    <span>{{ record.ownership }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>RFID:</strong>
                                                    <span>{{ record.rfid }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>App ID:</strong>
                                                    <span>{{ record.appId }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>Species:</strong>
                                                    <span>{{ record.species }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>Area:</strong>
                                                    <span>{{ record.area }}</span>
                                                </div>
                                                <div class="detail-row">
                                                    <strong>Location:</strong>
                                                    <a :href="'https://www.google.com/maps/search/?api=1&query=' + record.location"
                                                       target="_blank">Map</a>
                                                </div>
                                            </div>

                                            <!-- Show More/Less and View/Edit Buttons -->
                                            <div class="card-actions-row">
                                                <a href="#" class="show-more-link" @click.prevent="toggleCardExpansion(record.id)">
                                                    {{ expandedCards[record.id] ? 'Show Less' : 'Show More' }}
                                                    <i :class="expandedCards[record.id] ? 'ti-angle-up' : 'ti-angle-down'"></i>
                                                </a>
                                                <button type="button"
                                                        class="btn btn-warning btn-sm"
                                                        @click="viewHealthRecord(record.recordId)">
                                                    {{ isReadOnly ? 'View' : 'View/Edit' }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="gridData.length === 0" class="text-center py-5">
                                <p>No records to display</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isReadOnly" class="card-footer">
                        <button v-bind:disabled="!onLine" class="btn btn-warning mr-2" type="button"
                                @click="showModal=true">Mark for Release
                        </button>
                        <button v-bind:disabled="!onLine" class="btn btn-warning edit_btn mr-2" type="button"
                                @click="editBulkRecords">
                            Bulk Sterilization
                        </button>
                        <button v-bind:disabled="!onLine" class="btn btn-warning edit_btn mr-2" type="button"
                                @click="changeStageOfSelectedRecords">
                            Change Stage
                        </button>
                        <button type="button" class="btn" @click="archiveRecords">Archive</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal pm-mark-for-release-modal fade" role="dialog" v-if="showModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header edit-header">
                        <h4 class="modal-title">To be released date</h4>
                    </div>
                    <div class="modal-body modal-body-noteoprated">
                        <FullCalendar
                            height="100"
                            content-height="100"
                            aspect-ratio="1.8"
                            defaultView="dayGridMonth"
                            :plugins="calendarPlugins"
                            :selectable="true"
                            @select="handleSelect"
                        />
                    </div>
                    <hr/>
                    <div class="row set_footer">
                        <div class="col-md-8 selected-date">
                            <b>Selected Date :
                                {{ currentSelectDate != '' ? currentSelectDate : showDate.toLocaleDateString() }}</b>
                        </div>
                        <div class="col-md-4" style="text-align:right">
                            <button type="button" class="btn btn-default" style="background-color: var(--hw-danger) !important;"
                                    @click="showModal=false">Close
                            </button>
                            <button type="button" class="btn btn-default" style="background-color: var(--hw-pair1-secondary) !important;"
                                    @click="markForRelease">SUBMIT
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="showChangeStageDialog">
            <PmRecordStageChangerDialog
                :record-ids="selectedRecordIds"></PmRecordStageChangerDialog>
        </template>

    </div>
</template>
<script>
import mixin from '../../../../mixins/GlobalMixin';
import VOffline from 'v-offline';
import {Select, Option,} from 'element-ui';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'
import PmRecordStageChangerDialog from "../../../PmRecordStageChangerDialog";
import apiService from '../../../../services/api.service';
import { excelExportFormatter } from '../../../../utils/datatablesExportFormatter';
export default {
    components: {
        PmRecordStageChangerDialog,
        [Option.name]: Option,
        [Select.name]: Select,
        FullCalendar,
        VOffline
    },
    props: {
        projectId: {
            type: Number,
        }
    },
    data() {
        return {

            selectedRecordIds: [],
            showChangeStageDialog: false,

            isReadOnly: false,
            table: null,
            showModal: false,
            showDate: new Date(),
            currentSelectDate: '',
            calendarPlugins: [dayGridPlugin, interactionPlugin],
            viewMode: 'list', // 'list' or 'grid'
            gridData: [],
            expandedCards: {} // Track which cards are expanded
        }
    },
    mixins: [mixin],
    methods: {
        addHealthRecordViewListener(editEl) {
            let vm = this;
            editEl[0].addEventListener('click', function () {
                let id = this.getAttribute("data-data");
                vm.$router.push({name: 'HealthRecordDetailsPm', params: {recordId: id}})
            }, false);
        },
        NotOperatedRecords() {
            let vm = this;

            if (vm.table != null) {
                vm.table.destroy();
            }
            try {
                vm.table = $('#notOperatedRecords').DataTable({
                    "order": [[1, "desc"]],
                    "scrollX": true,
                    responsive: true,
                    dom: 'lBfrtip',
                    "bInfo": false,
                    'columns': [
                        {
                            'targets': 0,
                            'render': function (data, type, full, meta) {
                                return '<input type="checkbox" class="check_input" name="id[]" value="' + full[0] + '">';
                            },
                            'orderable': false
                        }, {
                            'targets': 1,
                            'render': function (data, type, full, meta) {
                                return vm.formatRecordDisplayDate(full[1], 'Do MMM YYYY, HH:mm:ss', ',');
                            }
                        },
                        {
                            'targets': 2,
                            'render': function (data, type, full, meta) {
                                return '<img src=' + full[2] + ' class="datatable_image_thumbnail" style="cursor: pointer; object-fit: cover;" height="70" width="70"/>';
                            }
                        },
                        {
                            'targets': 3,
                            'render': function (data, type, full, meta) {
                                return full[3];
                            }
                        }, {
                            'targets': 4,
                            'render': function (data, type, full, meta) {
                                return full[4];
                            }
                        }, {
                            'targets': 5,
                            'render': function (data, type, full, meta) {
                                return full[5];
                            }
                        }, {
                            'targets': 6,
                            'render': function (data, type, full, meta) {
                                return full[6];
                            }
                        }, {
                            'targets': 7,
                            'render': function (data, type, full, meta) {
                                return full[7];
                            }
                        }, {
                            'targets': 8,
                            'render': function (data, type, full, meta) {
                                return full[8];
                            }
                        }, {
                            'targets': 9,
                            'render': function (data, type, full, meta) {
                                return full[9];
                            }
                        }, {
                            'targets': 10,
                            'render': function (data, type, full, meta) {
                                return full[10];
                            }
                        }, {
                            'targets': 11,
                            'render': function (data, type, full, meta) {
                                return `<a href="https://www.google.com/maps/search/?api=1&query=${full[11]}" target="_blank">Map</a>`
                            }
                        }, {
                            'targets': 12,
                            'render': function (data, type, full, meta) {
                                if (vm.isReadOnly) {
                                    return '<button type="button" class="btn btn-warning viewHealthRecordDetails" data-data="' + full[12] + '">View</button>';
                                }
                                return '<button type="button" class="btn btn-warning viewHealthRecordDetails" data-data="' + full[12] + '">View/Edit</button>';
                            }
                        }
                    ],
                    buttons: [
                        {
                            extend: 'excel',
                            text: 'Export to excel',
                            className: 'btn btn-default',
                            filename: function () {
                                const date = new Date().toISOString().split('T')[0];
                                return `Awaiting_Evalution_${date}`;
                            },
                            exportOptions: {
                                columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                                format: excelExportFormatter({
                                    2: { type: 'image' },
                                    11: { type: 'map' }
                                }),
                            }
                        },
                        {
                            extend: 'colvis',
                            text: 'Filter Columns',
                            className: 'btn btn-default'
                        }
                    ],
                    "processing": true,
                    "serverSide": true,
                    "ajax": {
                        "url": window.DATATABLES_BASE_URL + "records/awaitingForEvaluation",
                        "type": "POST",
                        "data": {
                            project_id: vm.projectId,
                        }
                    },
                    'fnRowCallback': function (nRow, aData, iDisplayIndex) {
                        const viewEditBtn = $('.viewHealthRecordDetails', nRow);
                        vm.addHealthRecordViewListener(viewEditBtn);
                        const imageElement = $('.datatable_image_thumbnail', nRow);
                        vm.zoomImagePopup(imageElement);
                        return nRow;
                    },
                    lengthMenu: [[15, 100, -1], [15, 100, "All (Warning: Slow)"]],
                    pageLength: 15,
                    fixedHeader: {
                        header: true,
                        headerOffset: 60,
                    },
                });
            } catch (e) {
                console.log(e)
            }
        },
        editViewRecord() {
            var self = this;
            var editIcon = document.querySelectorAll('.view_edit');
            for (var i = 0; i < editIcon.length; i++) {
                editIcon[i].addEventListener('click', function () {
                    window.location = '/project/mark_release/' + self.projectId;
                }, false);
            }
        },
        inputCheckBox() {
            if (document.getElementById('allCheckbox').checked) {
                console.log("if");
                document.querySelectorAll('.check_input').forEach(function (element) {
                    element.checked = true;
                });
                // Also check grid view checkboxes
                document.querySelectorAll('.grid-check-input').forEach(function (element) {
                    element.checked = true;
                });
            } else {
                console.log("else");
                document.querySelectorAll('.check_input').forEach(function (element) {
                    element.checked = false;
                });
                // Also uncheck grid view checkboxes
                document.querySelectorAll('.grid-check-input').forEach(function (element) {
                    element.checked = false;
                });
            }
        },
        toggleToGridView() {
            const vm = this;
            vm.viewMode = 'grid';
            vm.extractDataFromTable();
        },
        extractDataFromTable() {
            const vm = this;
            vm.gridData = [];

            if (vm.table) {
                const data = vm.table.rows({search: 'applied'}).data();

                data.each(function(row) {
                    vm.gridData.push({
                        id: row[0],
                        caughtDate: vm.formatRecordDisplayDate(row[1], 'Do MMM YYYY, HH:mm:ss', ','),
                        photo: row[2],
                        collarId: row[3],
                        gender: row[4],
                        caughtMethod: row[5],
                        ownership: row[6],
                        rfid: row[7],
                        appId: row[8],
                        species: row[9],
                        area: row[10],
                        location: row[11],
                        recordId: row[12]
                    });
                });
            }
        },
        viewHealthRecord(recordId) {
            this.$router.push({name: 'HealthRecordDetailsPm', params: {recordId: recordId}})
        },
        zoomImagePopupGrid(imageSrc) {
            // Create a temporary image element and trigger zoom
            const tempImg = $('<img>').attr('src', imageSrc).addClass('datatable_image_thumbnail');
            this.zoomImagePopup(tempImg);
            // Trigger click to open zoom
            tempImg.trigger('click');
        },
        toggleCardExpansion(recordId) {
            this.$set(this.expandedCards, recordId, !this.expandedCards[recordId]);
        },
        isCardChecked(recordId) {
            const checkbox = document.querySelector(`.grid-check-input[value="${recordId}"]`);
            return checkbox ? checkbox.checked : false;
        },
        onCheckboxChange() {
            // Force re-render to update card borders
            this.$forceUpdate();
        },
        setShowDate(date) {
            this.showDate = date;
        },
        handleSelect(e) {
            let date = new Date(e.start);
            let fDate = (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear())
            this.currentSelectDate = fDate;
        },
        markForRelease() {
            let catch_release_record_ids = [];
            let selectDate;
            let vm = this;
            if (vm.currentSelectDate == '') {
                let date = new Date(vm.showDate);
                let fDate = (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear())
                selectDate = fDate;
            } else {
                selectDate = vm.currentSelectDate;
            }
            // Collect from both list and grid view checkboxes
            const allCheckboxes = [...document.querySelectorAll('.check_input'), ...document.querySelectorAll('.grid-check-input')];
            allCheckboxes.forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true) {
                    var checkInputValue = element.value;
                    if (!catch_release_record_ids.includes(checkInputValue)) {
                        catch_release_record_ids.push(checkInputValue);
                    }
                    axios.post('catch_release/mark_for_release', {
                        catch_release_record_ids: catch_release_record_ids,
                        release_date: selectDate,
                    }).then(response => {
                        if (response.data.response.error.error_code === 0) {
                            vm.showModal = false;
                            vm.showAlert('Success', response.data.response.error.msg, true);
                            vm.NotOperatedRecords();
                        }
                    }).catch(error => {
                        vm.showAlert('Error', error.response.data.response.error.error_msg, false);
                    })
                }
            })
            if (catch_release_record_ids.length == 0) {
                vm.showModal = false;
                vm.showAlert('Alert', 'Please select record(s)', false);
            }
        },
        changeStageOfSelectedRecords() {

            const vm = this
            vm.selectedRecordIds = []

            // Collect from both list and grid view checkboxes
            const allCheckboxes = [...document.querySelectorAll('.check_input'), ...document.querySelectorAll('.grid-check-input')];
            allCheckboxes.forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true && !vm.selectedRecordIds.includes(element.value)) {
                    vm.selectedRecordIds.push(element.value);
                }
            });

            if (vm.selectedRecordIds.length > 0) {
                vm.showChangeStageDialog = true
            } else {
                vm.showAlert('Alert', 'No records selected', false)
            }


        },
        editBulkRecords() {
            const selectedRecords = []
            // Collect from both list and grid view checkboxes
            const allCheckboxes = [...document.querySelectorAll('.check_input'), ...document.querySelectorAll('.grid-check-input')];
            allCheckboxes.forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true && !selectedRecords.includes(element.value)) {
                    selectedRecords.push(element.value);
                }
            });
            this.$router.push({
                name: 'EditBulkRecords',
                query: {
                    ref: 'awaitingEvaluation',
                    selectedRecordIds: JSON.stringify(selectedRecords),
                    fromText: 'Awaiting Evaluation'
                }
            })
        },
        async archiveRecords() {
            const vm = this;
            const selectedRecordIds = [];
            // Collect from both list and grid view checkboxes
            const allCheckboxes = [...document.querySelectorAll('.check_input'), ...document.querySelectorAll('.grid-check-input')];
            allCheckboxes.forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true && !selectedRecordIds.includes(element.value)) {
                    selectedRecordIds.push(element.value);
                }
            });

            if (selectedRecordIds.length > 0) {
                const loading = vm.$loading({
                    lock: true,
                    text: 'Archiving records...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const apiResponse = await apiService.archivePmRecords({ids: selectedRecordIds});

                loading.close();

                if (apiResponse.response.error.error_code === 0) {
                    vm.showModal = false;
                    vm.showAlert('Success', apiResponse.response.error.msg, true);
                    vm.NotOperatedRecords();
                } else {
                    vm.showAlert('Error', apiResponse.response.error.error_msg, false);
                }
            } else {
                vm.showAlert('Alert', 'No records selected', false)
            }
        }
    },
    computed: {},
    mounted() {
        let vm = this;

        window.Bus.$on('pm-close-stage-changer-dialog-box', function () {
            vm.showChangeStageDialog = false

            vm.NotOperatedRecords();
        })

        vm.project = vm.$store.getters.getCurrentSelectedProject;

        vm.projectId = vm.project.id;

        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true
            }
        })

        //Bus.$emit("projectype", vm.project);
        vm.NotOperatedRecords();
    }
}

</script>
<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

.containBytitile h4 {
    font-size: 1.2em;
    line-height: 1.45em;
}

// DataTable Controls Styling
.dataTables_wrapper {
    // Enhanced fixed header styling
    .fixedHeader-floating {
        background: white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .dataTables_length {
        margin-bottom: 15px;

        label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            color: #495057;
            font-weight: 500;

            select {
                padding: 6px 32px 6px 12px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                font-size: 14px;
                color: #374151;
                background-color: white;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E");
                background-position: right 8px center;
                background-repeat: no-repeat;
                background-size: 16px;
                appearance: none;
                cursor: pointer;
                transition: all 0.2s;

                &:hover {
                    border-color: #9ca3af;
                }

                &:focus {
                    outline: none;
                    border-color: #007bff;
                    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
                }
            }
        }
    }

    .dataTables_filter {
        margin-bottom: 15px;

        label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            color: #495057;
            font-weight: 500;

            input {
                padding: 8px 12px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                font-size: 14px;
                color: #374151;
                min-width: 250px;
                transition: all 0.2s;

                &:hover {
                    border-color: #9ca3af;
                }

                &:focus {
                    outline: none;
                    border-color: #007bff;
                    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
                }

                &::placeholder {
                    color: #9ca3af;
                }
            }
        }
    }

    .dt-buttons {
        display: inline-flex;
        gap: 8px;
        margin-bottom: 15px;

        .btn {
            padding: 8px 16px;
            font-size: 14px;
            font-weight: 600;
            border-radius: 6px;
            border: none;
            background: #007bff;
            color: white !important;
            transition: all 0.2s;
            display: inline-flex;
            align-items: center;
            gap: 6px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

            &:hover {
                background: #0056b3;
                transform: translateY(-1px);
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
            }

            &:active {
                transform: translateY(0px);
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
        }
    }

    .dataTables_info {
        font-size: 14px;
        color: #6b7280;
        padding: 12px 0;
    }

    .dataTables_paginate {
        padding: 12px 0;

        .paginate_button {
            padding: 6px 12px;
            margin: 0 2px;
            border: 1px solid #d1d5db;
            border-radius: 6px;
            background: white;
            color: #374151;
            font-size: 14px;
            transition: all 0.2s;
            cursor: pointer;

            &:hover {
                background: #f9fafb;
                border-color: #9ca3af;
                color: #1f2937;
            }

            &.current {
                background: #007bff;
                border-color: #007bff;
                color: white;
                font-weight: 600;

                &:hover {
                    background: #0056b3;
                    border-color: #0056b3;
                }
            }

            &.disabled {
                opacity: 0.5;
                cursor: not-allowed;

                &:hover {
                    background: white;
                    border-color: #d1d5db;
                    color: #374151;
                }
            }
        }
    }
}

// Grid View Notice Styles
.grid-view-notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    background: #e7f3ff;
    border: 1px solid #b3d9ff;
    border-radius: 8px;
    color: #004085;
    margin-bottom: 0;
    position: relative;

    i {
        font-size: 20px;
        color: #0066cc;
        margin-top: 2px;
        flex-shrink: 0;
    }

    .notice-content {
        flex: 1;
        font-size: 14px;
        line-height: 1.5;

        strong {
            font-weight: 600;
            color: #003366;
        }
    }

    .close {
        padding: 0;
        background: none;
        border: none;
        color: #004085;
        opacity: 0.6;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
        transition: opacity 0.2s;
        flex-shrink: 0;

        &:hover {
            opacity: 1;
        }

        span {
            display: block;
        }
    }
}

// Modern View Toggle Styles
.modern-view-toggle {
    display: inline-flex;
    background: #f0f2f5;
    padding: 3px;
    border-radius: 8px;
    gap: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    .toggle-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 14px;
        border: none;
        background: transparent;
        color: #65676b;
        font-weight: 500;
        font-size: 13px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        white-space: nowrap;

        i {
            font-size: 14px;
            transition: transform 0.3s ease;
        }

        span {
            font-weight: 600;
        }

        &:hover {
            color: #1c1e21;
            background: rgba(0, 0, 0, 0.05);
        }

        &.active {
            background: #ffffff;
            color: #007bff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);

            i {
                transform: scale(1.1);
            }
        }

        &:focus {
            outline: none;
        }
    }
}

// Grid View Styles
.grid-view-container {
    width: 100%;

    .record-card {
        background: #fff;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.2s, box-shadow 0.2s, border-color 0.3s;
        height: 100%;
        display: flex;
        flex-direction: column;

        &:hover {
            transform: translateY(-4px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        &.card-checked {
            border-color: #007bff;
            box-shadow: 0 4px 12px rgba(0, 123, 255, 0.25);
        }

        .record-image {
            width: 100%;
            height: 200px;
            position: relative;
            overflow: hidden;
            background: #f5f5f5;

            .checkbox-overlay {
                position: absolute;
                top: 10px;
                left: 10px;
                z-index: 10;

                input[type="checkbox"] {
                    cursor: pointer;
                    width: 20px;
                    height: 20px;
                    margin: 0;
                }
            }

            .image-content {
                width: 100%;
                height: 100%;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }

                &:hover img {
                    transform: scale(1.05);
                }
            }
        }

        .record-details {
            padding: 15px;
            flex-grow: 1;

            .detail-row {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding: 6px 0;
                border-bottom: 1px solid #f0f0f0;
                font-size: 0.9rem;

                &:last-child {
                    border-bottom: none;
                }

                strong {
                    color: #555;
                    font-weight: 600;
                    margin-right: 10px;
                    min-width: 80px;
                    flex-shrink: 0;
                }

                span, a {
                    color: #333;
                    text-align: right;
                    word-break: break-word;
                    flex-grow: 1;
                }

                a {
                    color: #007bff;
                    text-decoration: none;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .expandable-details {
                margin-top: 8px;
            }

            .card-actions-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 12px;
                padding-top: 10px;
                border-top: 1px solid #e0e0e0;

                .show-more-link {
                    color: #007bff;
                    text-decoration: none;
                    font-weight: 500;
                    font-size: 0.9rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    transition: color 0.2s;

                    &:hover {
                        color: #0056b3;
                        text-decoration: none;
                    }

                    i {
                        font-size: 0.85rem;
                    }
                }

                .btn {
                    font-weight: 500;
                    padding: 6px 12px;
                    font-size: 0.875rem;
                }
            }
        }
    }
}

@media (max-width: 425px) {
    .edit_btn {
        margin-top: 10px !important;
    }

    .modern-view-toggle {
        width: 100%;

        .toggle-btn {
            flex: 1;
            justify-content: center;
            padding: 10px 12px;
            font-size: 13px;

            span {
                display: none;
            }

            i {
                font-size: 18px;
            }
        }
    }

    .grid-view-container {
        .record-card {
            .record-image {
                height: 180px;
            }

            .record-details {
                .detail-row {
                    flex-direction: column;
                    align-items: flex-start;

                    strong {
                        margin-bottom: 4px;
                    }

                    span, a {
                        text-align: left;
                    }
                }
            }
        }
    }
}
</style>
